<template>
  <div class="col-100 recherche-avancee-usages-cultures">
    <div class="usage-cultures">
      <label for="usage-cultures" class="label-bold">Cultures</label>
      <div>
        <div
          class="relative "
          v-for="(cultivation, index) in cultivations"
          :key="index"
        >
          <v-select
            :value="cultivation || selectedDefault"
            :options="cultivationsOptions"
            :clearable="false"
            @input="$emit(
              'update:cultivations',
              cultivations.map((x, ind) => ind === index ? reduce($event) : x)
            )"
            id="usage-cultures"
          >
          </v-select>
          <div
            v-if="index === cultivations.length - 1"
            class="ajout-element"
            @click="$emit('update:cultivations', cultivations.concat(['']));"
          ></div>
          <div
            v-else
            class="suppr-element"
            @click="$emit('update:cultivations', cultivations.filter((value, i) => i !== index));"
          ></div>
        </div>
      </div>
    </div>

    <div class="usage-cibles">
      <label for="usage-cibles" class="label-bold">Cibles</label>
      <div>
        <div
          class="relative"
          v-for="(target, index) in targets"
          :key="target"
        >
          <v-select
            :value="target || selectedDefault"
            :options="targetsOptions"
            :clearable="false"
            @input="$emit(
              'update:targets',
              targets.map((x, ind) => ind === index ? reduce($event) : x)
            )"
            id="usage-cibles"
          >
          </v-select>
          <div
            v-if="index === targets.length - 1"
            class="ajout-element"
            @click="$emit('update:targets', targets.concat(['']))"
          ></div>
          <div
            v-else
            class="suppr-element"
            @click="$emit('update:targets', targets.filter((value, i) => i !== index))"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UsesForm',

  props: {
    cultivations: Array,
    targets: Array,

    cultivationsRef: Array,
    targetsRef: Array
  },

  data () {
    return {
      selectedDefault: { value: '', label: 'Toutes' }
    }
  },

  computed: {
    cultivationsOptions () {
      let array = [...this.cultivationsRef]
      array.unshift(this.selectedDefault)
      return array
    },

    targetsOptions () {
      let array = [...this.targetsRef]
      array.unshift(this.selectedDefault)
      return array
    }
  },

  methods: {
    reduce (returnedItem) {
      return returnedItem.hasOwnProperty('value') ? returnedItem.value : returnedItem
    }
  }
}
</script>
